const keyPrefix = `logto_cache`;
class CacheStorage {
    constructor(appId) {
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) {
            return `${keyPrefix}:${this.appId}`;
        }
        return `${keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        return sessionStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        sessionStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        sessionStorage.removeItem(`${this.getKey(key)}`);
    }
}

export { CacheStorage };
